export function getNewsletterLiterals(t: any): any {
    return {
        title1: t("ui-newsletter.title1"),
        input: {
            maintext: t("ui-newsletter.input.maintext"),
        },
        button: t("ui-newsletter.button"),
        title2: t("ui-newsletter.title2"),
        title3: t("ui-newsletter.title3"),
        modalError: {
            title: t("ui-newsletter.modalError.title"),
            desc: t("ui-newsletter.modalError.desc"),
            buttonText: t("ui-newsletter.modalError.buttonText")
        },
        inputError: {
            maintext: t("ui-newsletter.inputError.maintext")
        },
        modalPrivacy: {
            title: t("ui-newsletter.modalPrivacy.title"),
            desc1: t("ui-newsletter.modalPrivacy.desc1"),
            desc2: t("ui-newsletter.modalPrivacy.desc2"),
            link: {
                text: t("ui-newsletter.modalPrivacy.link.text"),
                href: t("ui-newsletter.modalPrivacy.link.href"),
            },
            buttonsFooter: [
                {
                    text: t("ui-newsletter.modalPrivacy.buttonsFooter.cancel"),
                    style: "outline",
                    id: "cancel"
                },
                {
                    text: t("ui-newsletter.modalPrivacy.buttonsFooter.continue"),
                    style: "primary",
                    id: "continue"
                }
            ]
        }
    }
}